$shm_hitalama_map_widget_float_settings_echarts $shm_hitalama_map_widget_float_settings
	controls /
		<= Settings_scroll
	controlled_settings_content /
		<= Axis_field $mol_form_field
			name \Ось
			Content <= Axis_content $mol_view
				sub /
					<= Axis $mol_select
						Filter null
						options <= table_head /
						value? <=> axis? \
					^ axis_details_visible / <= Axis_details $mol_select
						Filter null
						dictionary *
							day \День
							month \Месяц
							year \Год
						value? <=> axis_details? \day
		<= Values_field $mol_form_field
			name \Значения
			Content <= Values $mol_select
				Filter null
				options <= table_head /
				value? <=> values_title? \
		<= Groups_field $mol_form_field
			name \Группировка
			Content <= Groups $mol_select_list
				value? <=> groups? /
				options <= table_head /
		<= Type_field $mol_form_field
			name \Тип
			Content <= Type $mol_select
				Filter null
				dictionary *
					line \Линия
					bar \Столбцы
					scatter \Точки
					pie \Пирог
				value? <=> chart_type? \line
		<= Legend $mol_check_box
			title \Легенда
			checked? <=> legend_show? true
		<= Smooth $mol_check_box
			title \Сглаживать
			checked? <=> smooth? false
		<= Area $mol_check_box
			title \Заливка
			checked? <=> area? false
		<= Stack $mol_check_box
			title \Стек
			checked? <=> stacked? false
		<= Toolbox $mol_check_box
			title \Инструменты
			checked? <=> toolbox_show? true
		<= Data_zoom $mol_check_box
			title \Масштабирование
			checked? <=> data_zoom_show? false
